"use strict";
// @ts-ignore
try {
    self['workbox:streams:6.5.3'] && _();
}
catch (e) { }
